var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77026 16.0593C2.77026 8.3176 8.97949 2.05927 16.6174 2.05927C24.2554 2.05927 30.4646 8.3176 30.4646 16.0593C30.4646 23.8009 24.2554 30.0593 16.6174 30.0593C8.97949 30.0593 2.77026 23.8009 2.77026 16.0593ZM16.6174 0.0592651C7.85566 0.0592651 0.770264 7.23239 0.770264 16.0593C0.770264 24.8861 7.85566 32.0593 16.6174 32.0593C25.3792 32.0593 32.4646 24.8861 32.4646 16.0593C32.4646 7.23239 25.3792 0.0592651 16.6174 0.0592651ZM18.165 16.7182V24.879H14.8229V16.7185H13.1531V13.9062H14.8229V12.2178C14.8229 9.92354 15.7657 8.55929 18.4444 8.55929H20.6745V11.3719H19.2805C18.2378 11.3719 18.1688 11.7649 18.1688 12.4984L18.165 13.9059H20.6903L20.3948 16.7182H18.165Z",
    fill: "#F3DD8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.59c2ebc2114eb88d215be1ea061d2545.svg";
export { ForwardRef as ReactComponent };